import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

const SelectionViewSwitchers = (props) => {

  const {activeSubPart, selectionWindowView, handleChangeListView, wizardConfig, isMobile} = props;

  let showListView = true;
  if (activeSubPart && wizardConfig.length) {
    const existingWizSetup = wizardConfig.find(wizObject => {
      return wizObject.featureGroupName === activeSubPart.part.dbName || wizObject.featureGroupName === activeSubPart.part.partName
    });
    if (existingWizSetup && existingWizSetup.filterGroups.length && !existingWizSetup.isFinished && existingWizSetup.enableForQuoting) {
      showListView = false
    }
  }

  return (
    <div className="bv-item-header__view">
      <button className={"bv-item-header__view-button" + (selectionWindowView === 1 ? " bv-item-header__view-button--active" : "")}
              data-view={1} onClick={handleChangeListView}>
        <span/>
      </button>
      <button className={"bv-item-header__view-button" + (selectionWindowView === 2 ? " bv-item-header__view-button--active" : "")}
              data-view={2} onClick={handleChangeListView}>
        <p><span/><span/><span/></p>
        <p><span/><span/><span/></p>
      </button>
      {isMobile ? null : (
        <button className={"bv-item-header__view-button" + (selectionWindowView === 3 ? " bv-item-header__view-button--active" : "")}
                data-view={3} onClick={handleChangeListView}>
          <p><span/><span/><span/></p>
          <p><span/><span/><span/></p>
          <p><span/><span/><span/></p>
        </button>
      )}
      {showListView ? (
        <button className={"bv-item-header__view-button" + (selectionWindowView === 4 ? " bv-item-header__view-button--active" : "")}
                data-view={4} onClick={handleChangeListView}>
          <p><span/></p>
          <p><span/></p>
          <p><span/></p>
        </button>
      ) : null}
    </div>
  );
};

SelectionViewSwitchers.propTypes = {
  activeSubPart: PropTypes.object,
}

const mapStateToProps = (store) => {
  const {wizardConfig} = store.wizardState;
  const {selectionWindowView} = store.selectionState;
  const {isMobile} = store.serverState;
  return {
    wizardConfig,
    selectionWindowView,
    isMobile
  }
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionViewSwitchers);
